import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTheme } from 'styled-components';
import { PlaidLink, usePlaidLink } from "react-plaid-link";
import { Skeleton, Modal, Table, Badge, Alert, Tooltip } from 'antd';
import LucideIcon, { TextButton, Button, ImageButton } from '../../Reusable/Button'

import { Flex, FlexColumn, InputContainer, LightContainer } from '../../Reusable/Container'
import { ErrorAlert } from '../../Reusable/Alert';
import environment from '../../../environment';
import { apiGET, apiPOST, apiPOSTReq } from '../../../Utils/api';
import { PlusOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { Text, Tag } from '../../Reusable/Text'
import { Image } from '../../Reusable/Image'
import { LabeledInput } from '../../Reusable/Input'
import { addDataToStore, CREDIT_SAVE_DATA, SAVE_DATA } from '../../../Actions/actions';
import Info from '../../Reusable/Info';
import BankIcon from '../../../Images/bank-generic.png';
import Delete from '../../../Images/delete-red-icon.png'
import { getUserApps } from '../../../Utils/util';
import AlertModal from '../../Reusable/AlertModal';
import ModalClose from '../../../Images/modal-close.png'

class Index extends Component {
    state = {
        loading: false,
        loadingBanks: false,
        showBankDetails: false,
        linkToken: '',
        reconnectBank: false,
        loadTransactions: false,
        reconnectBanner: false,
        yodleeLink: false,
        loadingButton: null,
        pollingInterval: 3000,
        minimumDeposit: this.props.minimumDeposit,
        accountDetails: this.props.accountDetails,
    }

    componentDidMount() {
        this.getPlaidLinkToken();
        // this.fetchBanks();
        const allowedApps = getUserApps(this.props.aionStore)
        if (allowedApps.includes("ARCredit") || allowedApps.includes("TermLoans") || allowedApps.includes("ABLCredit")) {
            this.setState({ creditCustomer: true })
        }
    }

    fetchBanks = () => {
        const body = {
            "BusinessId": this.props.aionStore.BusinessUniqueKey
        }

        this.setState({ loadingBanks: true })
        apiPOSTReq(`${environment.integrationBaseUrl}/integration/plaid/getInstitutionInfo`, {}, body, (err, resp) => {
            try {
                const data = resp;
                console.log("fetchBankInfo", data.externalBBInstitutions)
                var bankInfo = data.externalBBInstitutions
                // this.props.dispatch(addDataToStore(CREDIT_SAVE_DATA, bankInfo));
                this.props.dispatch(addDataToStore(CREDIT_SAVE_DATA, { externalBBInstitutions: bankInfo }));

                for (let index = 0; index < bankInfo.length; index++) {
                    if (bankInfo[index].status != "Connected") {
                        this.setState({ reconnectBanner: true })
                    }
                }
                this.setState({ banks: bankInfo })
            } catch (error) {
                console.log("ERROR", error.stack)
            } finally {
                this.setState({ loadingBanks: false })
            }
        })
    }

    getPlaidLinkToken = (mode) => {
        const { refNum, setConnectCTALoading } = this.props;
        var header = {
            AionAuth: refNum,
        }
        var body = {
            "redirectUri": window.location.href,
            // "BusinessId": this.props.aionStore.BusinessUniqueKey,
            "plaidMode": mode
        }

        body.customizationName = "accounts_only"

        if (mode == "update") {
            this.setState({ loadingUpdate: true })
            body.accessToken = this.state.bankAccessToken
        }

        console.log("CustomerPayment getLinkTokenForExternalUsers header, body", header, body)

        apiPOSTReq(`${environment.integrationBaseUrl}/integration/plaid/getLinkTokenForExternalUsers`, header, body, (err, resp) => {
            try {
                const response = resp || {};
                console.log("CustomerPayment getLinkTokenForExternalUsers resp", resp)
                if (response.result) {
                    this.setState({ linkToken: response.linkToken })
                    if (mode == "update") {
                        this.setState({ updateLinkToken: response.linkToken, loadingUpdate: false })
                    }
                } else {
                    ErrorAlert({ description: response.responseMessage });
                }
            } catch (err) {
                setConnectCTALoading(false)
            }
        })
    }

    getAccountDetailsForAutoDebit = (public_token, metadata, includeAuth, accessToken, mode) => {
        this.setState({ loadingReconnect: true })
        if (mode == "update") {
            this.setState({ loadingUpdate: true, showBankDetails: true })
        } else {
            this.setState({ loadingBanks: true })
        }

        const { refNum, setConnectCTALoading, setAccountDetails } = this.props;
        var header = {
            AionAuth: refNum,
        }

        var body = {
            "redirectUri": window.location.href,
            "plaidTokenData": {
                publicToken: public_token,
                accountId: metadata.account.id,
                accountName: metadata.account.name,
                institution: metadata.institution.name,
                institutionId: metadata.institution.institution_id,
            },
            "includeAuth": includeAuth,
            "accessToken": accessToken,
            "plaidMode": mode,
        }
        console.log("CustomerPayment getAccountDetailsForAutoDebit body", body)

        setConnectCTALoading(true)

        apiPOSTReq(`${environment.integrationBaseUrl}/integration/plaid/getAccountDetailsForAutoDebit`, header, body, (err, resp) => {
            try {
                const data = resp || {};
                console.log("CustomerPayment getAccountDetailsForAutoDebit resp", resp)
                if (data.result) {
                    setAccountDetails(data)
                    this.setState({ accountDetails: data });
                } else {
                    throw Error(data.responseMessage || data.error);
                }
            } catch (error) {
                console.log("CustomerPayment getAccountDetailsForAutoDebit ERROR", error, resp)
                ErrorAlert({ description: error.message })
            } finally {
                this.setState({ loadingBanks: false })
                setConnectCTALoading(false)
            }
        })
    }

    startPolling = (initialResponse, mode) => {
        this.pollingTimer = setInterval(() => {
            this.checkAccountStatus((response) => {
                if (response && response.result) {
                    this.handleSuccess(response, mode);
                    this.stopPolling();
                }
            });
        }, this.state.pollingInterval);
    };

    checkAccountStatus = (callback) => {
        var body = {
            "itemId": this.state.itemId
        }
        apiPOSTReq(`${environment.integrationBaseUrl}/integration/plaid/getAccountDetails`, {}, body, (err, resp) => {
            if (err) {
                console.error('Polling error:', err);
                return;
            }
            callback(resp);
        });
    };

    handleSuccess = (response, mode) => {
        this.setState({ reconnectBanner: false, loadingReconnect: false });
        if (mode === 'update') {
            this.handleBankDetails(this.state.bankInfo);
        } else {
            this.setState({ loadingUpdate: false });
            this.fetchBanks();
        }

        if (this.props.onComplete && this.props.minimumDeposit) {
            this.props.onComplete(response.accountsList[0]);
        } else if (this.props.onComplete) {
            this.props.onComplete()
        }
    };

    stopPolling = () => {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
    };


    logPlaidEvent = (eventName, metadata) => {
        apiPOST("/logError", {}, { logType: "PLAID_DESKTOP", eventName: eventName, metadata: metadata }, (err, resp) => {
            // console.log("Plaid event logged", err, resp);
        });
    }

    handleBankDetails = (bankInfo) => {
        bankInfo = bankInfo || {}
        this.setState({ loading: true, loadingButton: bankInfo.itemId })
        if (bankInfo.integrationProvider == "Plaid") {
            const body = {
                "itemId": bankInfo.itemId,
                "redirectUri": window.location.href,
                "connectionStatus": bankInfo.status

            }

            console.log("Metabody:", body)
            apiPOSTReq(`${environment.integrationBaseUrl}/integration/plaid/getAccountDetails`, {}, body, (err, resp) => {
                try {
                    const response = resp || {};
                    this.setState({ loading: false, loadingButton: null })
                    if (response.result) {
                        bankInfo = response.bankInfo || {}
                        this.setState({
                            accountDetails: response.accountsList, showBankDetails: true, bankStatus: bankInfo.status,
                            bankUrl: bankInfo.logoUrl, bankName: bankInfo.bankName, bankLastUpdated: bankInfo.lastUpdatedAt, relinkToken: response.linkToken,
                            bankAccessToken: bankInfo.accessToken, reconnectBank: false, loadingUpdate: false, itemId: bankInfo.itemId, bankInfo: bankInfo,
                        },
                            () => {
                                this.getPlaidLinkToken("update");
                            })
                        if (bankInfo.status != "Connected") {
                            this.setState({ reconnectBank: true })
                        }
                    } else {
                        ErrorAlert({ description: response.responseMessage });
                    }
                } catch (err) {

                }
            })
        } else {
            const body = {
                "providerAccountId": bankInfo.providerAccountId,
            }

            apiPOSTReq(`${environment.integrationBaseUrl}/integration/yodlee/getAccountDetails`, {}, body, (err, resp) => {
                try {
                    const response = resp || {};
                    if (response.result) {
                        this.setState({
                            accountDetails: response.accountsList, showBankDetails: true, bankStatus: bankInfo.status,
                            bankUrl: bankInfo.logoUrl, bankName: bankInfo.bankName, bankLastUpdated: bankInfo.lastUpdatedAt, relinkToken: response.linkToken,
                            bankAccessToken: bankInfo.accessToken, reconnectBank: false, itemId: bankInfo.itemId
                        })
                        if (bankInfo.status != "Connected") {
                            this.setState({ reconnectBank: true })
                        }
                    } else {
                        ErrorAlert({ description: response.responseMessage });
                    }
                } catch (err) {

                }
            })
        }
    }

    render() {
        const { onBack, backCTAText, connectCTA } = this.props;
        const { linkToken, loadingBanks, accountDetails, showBankDetails } = this.state;

        return (
            <>
                {
                    accountDetails ?
                        <Flex centerH gap="12px">
                            <LightContainer padding='8px 16px' margin='0 5px 5px 0' height='56px' onClick={() => this.setState({ showBankDetails: true })} clickable>
                                <Flex style={{ height: '100%' }} start centerHorizontally>
                                    <img style={{ marginRight: 8 }} height='24px' src={accountDetails.bankLogoUrl ? `${accountDetails.bankLogoUrl}` : BankIcon} />
                                    <Text size="16px" margin="0 12px 0 0">{accountDetails.bankName}</Text>
                                    {accountDetails.accountNumber && <Tag>{accountDetails.accountNumber.substring(accountDetails.accountNumber.length - 4, accountDetails.accountNumber.length)}</Tag>}
                                </Flex>
                            </LightContainer>

                            {
                                onBack &&
                                <TextButton weight='400' underline text={backCTAText || "Choose different account"} onClick={() => {
                                    this.setState({ accountDetails: null }, () => onBack())
                                }} />
                            }
                        </Flex>
                        :
                        <>
                            <PlaidLink
                                {...environment.plaid}
                                token={linkToken}
                                className='plaid-link-button plaid-modal-override'
                                selectAccount="false"
                                clientName="Aion"
                                isWebview="true"
                                apiVersion="v2"
                                onSuccess={(public_token, metadata) => {
                                    if (this.props.onSuccess) this.props.onSuccess() // Called when Plaid model closes and hands off to Aion
                                    this.getAccountDetailsForAutoDebit(public_token, metadata, true, null, null)
                                }}
                                onExit={() => this.setState({ yodleeLink: true })}
                                onCancel={() => this.setState({ yodleeLink: true })}
                                style={{ background: 'transparent', padding: 0, fontSize: 18, cursor: 'pointer' }}
                                onEvent={this.logPlaidEvent()}
                            >
                                {
                                    connectCTA ?
                                        connectCTA
                                        :
                                        <TextButton text='ADD NEW' loading={loadingBanks} icon={<PlusOutlined />} />
                                }
                            </PlaidLink>
                        </>
                }

                <Modal
                    visible={showBankDetails}
                    footer={null}
                    onCancel={() => this.setState({ showBankDetails: false })}
                    width={400}
                    zIndex={2000}
                    closeIcon={<Image src={ModalClose} />}
                >
                    <FlexColumn gap="24px" style={{ paddingLeft: 12 }}>
                        <Text heading>Bank Details</Text>
                        <Text>
                            <img style={{ marginRight: 8 }} height='35px' src={accountDetails?.bankLogoUrl ? accountDetails?.bankLogoUrl : BankIcon} />
                            {accountDetails?.bankName}
                        </Text>

                        <Flex start gap="24px">
                            <LabeledInput
                                type='read-only'
                                label="Routing Number"
                                value={accountDetails?.routingNumber}
                            />

                            <LabeledInput
                                type='read-only'
                                label="Account Number"
                                value={accountDetails?.accountNumber}
                            />
                        </Flex>

                        <LabeledInput
                            type='read-only'
                            label="Account Type"
                            value={accountDetails?.accountType}
                            width='288px'
                            capitalize
                        />
                    </FlexColumn>
                </Modal>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        aionStore: state.aionAppReducer,
        bankingStore: state.bankingAppReducer,
        creditStore: state.creditAppReducer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme(Index));